'use client';

import { createContext, useContext, useCallback, ReactNode } from 'react';
import { playerModelV2 } from '@/models/playerModelV2';

interface NameFormattingContextType {
  isJapanese: boolean;
}

const NameFormattingContext = createContext<NameFormattingContextType>({ isJapanese: false });

export function NameFormattingProvider({
  isJapanese,
  children,
}: {
  isJapanese: boolean;
  children: ReactNode;
}) {
  return (
    <NameFormattingContext.Provider value={{ isJapanese }}>
      {children}
    </NameFormattingContext.Provider>
  );
}

export function useNameFormatting() {
  return useContext(NameFormattingContext);
}

export function useFormatName() {
  const { isJapanese } = useContext(NameFormattingContext);
  return useCallback(
    (
      firstName: string | null,
      lastName: string | null,
      alias?: string | null,
      options?: { maxLength?: number },
    ) => {
      return playerModelV2.formatName(firstName, lastName, alias, { isJapanese, ...options });
    },
    [isJapanese],
  );
}
